import React, { useEffect, useState } from 'react';
import { Container, Header } from '../facts/styles';
import { IoSearch } from 'react-icons/io5';
import { useDispatch, useSelector } from 'react-redux';
import {
  getMealCategories,
  getMealCategoriesLoading,
  getMealCategoriesPageStats
} from './redux/selector';
import { delete_meal_categories, get_meal_categories } from './redux/reducer';
import useDebounce from '@app/Hooks/useDebounce';
import LoadingDataUi from '@app/components/loading';
import Pagination from '@app/components/pagination';
import MealCategoryTable from './components/table';
import { FormsModal } from '@app/globalstyles/asgard';
import AddMealCategory from './components/addMealCategory';

const MealCategories = () => {
  const meal_categories = useSelector(getMealCategories);
  const loading = useSelector(getMealCategoriesLoading);
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const pageStats = useSelector(getMealCategoriesPageStats);
  const [show, setShow] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [content, setContent] = useState({});
  const [search, setSearch] = useState('');
  const debouncedTerm = useDebounce(search, 500);

  useEffect(() => {
    dispatch(get_meal_categories({ page, limit, search: debouncedTerm }));
  }, [dispatch, page, limit, debouncedTerm]);

  function StopBubbling(e) {
    e.stopPropagation();
  }

  const getNewMealCategories = (page, limit) => {
    dispatch(get_meal_categories({ page, limit, debouncedTerm }));
  };

  const handlePageChange = (page) => {
    setPage(page);
    getNewMealCategories(page, limit);
  };
  const handlePageSizeChange = () => {
    setLimit(parseInt(limit));
    setPage(1);
    getNewMealCategories(1, limit);
  };

  const handleDelete = (doc) => {
    dispatch(delete_meal_categories(doc));
  };

  const handleEdit = (doc) => {
    setContent(doc);
    setIsEdit(!isEdit);
    setTimeout(() => {
      setShow(!show);
    }, 400);
  };

  return (
    <Container>
      {show && (
        <FormsModal show={show} onClick={() => setShow(!show)}>
          <div onClick={StopBubbling}>
            <AddMealCategory
              onClose={() => setShow(!show)}
              isEdit={isEdit}
              content={content}
            />
          </div>
        </FormsModal>
      )}
      <Header>
        <h4>Meal Facts</h4>

        <div className="search_box">
          <IoSearch size={20} color="#64748B" />
          <input
            placeholder="Search for a meal category..."
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <button
          onClick={() => {
            setContent({});
            setIsEdit(false);
            setTimeout(() => {
              setShow(!show);
            }, 400);
          }}
        >
          Add Category
        </button>
      </Header>

      {loading ? (
        <LoadingDataUi />
      ) : (
        <div>
          <MealCategoryTable
            category={meal_categories}
            handleDelete={handleDelete}
            handleEdit={handleEdit}
          />

          <Pagination
            itemsCount={pageStats.docs}
            currentPage={page}
            pageSize={limit}
            onChangePageSize={handlePageSizeChange}
            onPageChange={handlePageChange}
          />
        </div>
      )}
    </Container>
  );
};

export default MealCategories;
